import { useInfinitePicker, type UseInfinitePickerParams } from '@/components/Form/pickers/hooks';

import ComboboxList, { type ComboboxListProps } from './ComboboxList';

export type InfiniteComboboxListProps = ComboboxListProps & UseInfinitePickerParams;

const InfiniteComboboxList = ({
  fetchNextPage,
  loadMore,
  hasMore,
  isLoading,
  isFetchingNextPage,
  loadingOffsetPx,
  onScroll,
  ...props
}: InfiniteComboboxListProps) => {
  const { onListScroll } = useInfinitePicker({
    fetchNextPage,
    loadMore,
    hasMore,
    isLoading,
    isFetchingNextPage,
    loadingOffsetPx,
  });

  const handleScroll: ComboboxListProps['onScroll'] = (event) => {
    onListScroll(event);
    onScroll?.(event);
  };

  return <ComboboxList {...props} onScroll={handleScroll} />;
};

export default InfiniteComboboxList;
